interface Env {
  isPPE: boolean
  isBoe: boolean
  isDev: boolean
  isProd: boolean
  isTest: boolean
}

const getEnv: () => Env = () => {
  if (typeof window !== 'undefined') {
    return JSON.parse(
      (document?.getElementById('lite-config') as HTMLTextAreaElement)?.value ?? '{}',
    )
  } else {
    return {}
  }
}

export const env = getEnv()
